import { WorkOrderSimple } from "@/store/modules/workOrders";
import { debounce } from "@/utilities/debounce";

import { computed, ref } from "@vue/composition-api";

import {
  arrowUpHandler,
  arrowDownHandler,
  filterOnInputHandler,
  filterItems,
} from "@/utilities/pickListHelpers";

import store from "@/store";

export const filterableKeys: Array<keyof WorkOrderSimple> = [
  "name",
  "client_name",
  "field_name_with_cutting",
  "status",
  "commodity",
  "start_date",
  "completed_date",
];

export const filterWorkOrders = (filter: string, wo: WorkOrderSimple[]) => {
  return filterItems(filter, filterableKeys, wo);
};

export const debouncedFilteredWorkOrders = debounce(filterWorkOrders, 500);

export const apiWorkOrders = computed(() => {
  return store.getters.workOrdersForTable as WorkOrderSimple[];
});

export const workOrders = ref<WorkOrderSimple[]>([]);
